/**
 * Componente de checklist de objetivos medibles
 * Muestra el estado de cada objetivo (✅ cuando está completado)
 */

import React from 'react';
import { LessonObjective, UserLessonProgress, ObjectiveStatus } from '../../services/academicService';
import './LessonChecklist.css';

interface LessonChecklistProps {
  objectives: LessonObjective[];
  progress: UserLessonProgress | null;
  onObjectiveUpdate: (objectiveDescription: string, isCorrect: boolean) => void;
  isActivityActive: boolean;
}

const LessonChecklist: React.FC<LessonChecklistProps> = ({
  objectives,
  progress,
  onObjectiveUpdate: _onObjectiveUpdate,
  isActivityActive: _isActivityActive,
}) => {
  const getObjectiveStatus = (objective: LessonObjective): ObjectiveStatus | null => {
    if (!progress || !progress.objectives_status) return null;
    const status = progress.objectives_status[objective.description];
    if (!status || typeof status !== 'object') return null;
    
    return status as ObjectiveStatus;
  };

  const getProgressDisplay = (status: ObjectiveStatus | null): string => {
    if (!status) return '';
    if (status.completed) return '✅';
    return '';
  };

  const getProgressClass = (status: ObjectiveStatus | null): string => {
    if (!status) return 'objective-pending';
    if (status.completed) return 'objective-completed';
    const correctCount = status.correct_count ?? 0;
    if (correctCount > 0) return 'objective-in-progress';
    return 'objective-pending';
  };

  return (
    <div className="lesson-checklist">
      <h3>Objetivos de la Lección</h3>
      <div className="objectives-list">
        {objectives.map((objective) => {
          const status = getObjectiveStatus(objective);
          const progressDisplay = getProgressDisplay(status);
          const progressClass = getProgressClass(status);

          return (
            <div key={objective.id} className={`objective-item ${progressClass}`}>
              {progressDisplay && (
                <div className="objective-header">
                  <span className="objective-progress">{progressDisplay}</span>
                </div>
              )}
              <div className="objective-description">{objective.description}</div>
            </div>
          );
        })}
      </div>

      {progress && (
        <div className="lesson-progress-summary">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${
                  (Object.values(progress.objectives_status).filter((s) => s && s.completed).length /
                    objectives.length) *
                  100
                }%`,
              }}
            />
          </div>
          <div className="progress-text">
            {Object.values(progress.objectives_status).filter((s) => s && s.completed).length} /{' '}
            {objectives.length} objetivos completados
          </div>
        </div>
      )}
    </div>
  );
};

export default LessonChecklist;

